module.exports = __webpack_public_path__ + "img/wm.0b67c1e9.png";